import React from 'react';

const Loading = () => (
  <div className="loading">
    <span className="loading__bounce loading__bounce1" />
    <span className="loading__bounce loading__bounce2" />
    <span className="loading__bounce loading__bounce3" />
  </div>
);

export default Loading;
